// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3in0e","col":"styles_col__2nScA"};